export const getIsLoaderVisible = state => state.loader.get('isVisible')
